module.exports = __webpack_public_path__ + "assets/img/仓库打包中.096839bd.svg";